import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProductCustomizationOption } from '../../../common/interfaces';

@Component({
    selector: 'vsf-product-inline-custom-options',
    templateUrl: './product-inline-custom-options.component.html',
})
export class ProductInlineCustomOptionsComponent {
    @Input() allCustomizationOptions: ProductCustomizationOption[] = [];
    @Input() messageValues: { [optionId: string]: string } = {};
    @Input() selectedPaidOptionValues: { [optionId: string]: string } = {};

    @Output() messageChange = new EventEmitter<{ optionId: string; value: string }>();
    @Output() paidOptionChange = new EventEmitter<{ optionId: string; key: string }>();

    onMessageInput(optionId: string, value: string): void {
        console.log('Emitting message change', { optionId, value });
        this.messageChange.emit({ optionId, value });
    }

    onSelectPaidOption(optionId: string, key: string): void {
        console.log('Emitting paid option change', { optionId, key });
        this.paidOptionChange.emit({ optionId, key });
    }

    isNoneSelected(optionId: string): boolean {
        console.log('Checking if None is selected for option', { optionId, selectedValue: this.selectedPaidOptionValues[optionId] });
        return !this.selectedPaidOptionValues[optionId];
    }

    getSelectedPaidOptionLabel(option: ProductCustomizationOption, selectedKey: string): string {
        if (!selectedKey || !option.paidOption?.options) return selectedKey;
        return option.paidOption.options.find(item => item.key === selectedKey)?.label ?? selectedKey;
    }
}
